import contracts from './contracts'
import { FarmConfig, QuoteToken } from './types'

const farms: FarmConfig[] = [
  {
    pid: 0,
    risk: 5,
    lpSymbol: 'SPOCK-DAI LP',
    lpAddresses: {
      97: '',
      250: '0x0De9Ed19acd438B3AE7ab468AB6c5C2C788aE1EA',
    },
    tokenSymbol: 'SPOCK',
    tokenAddresses: {
      97: '',
      250: '0xE2463256E69E4C86345DC32e2FFED3283b0022e8',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 1,
    risk: 5,
    lpSymbol: 'SPOCK-FTM LP',
    lpAddresses: {
      97: '',
      250: '0x5252CAC3A9b04a272491Eac38a769E23D1f4Dccd',
    },
    tokenSymbol: 'SPOCK',
    tokenAddresses: {
      97: '',
      250: '0xE2463256E69E4C86345DC32e2FFED3283b0022e8',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 28,
    risk: 5,
    lpSymbol: 'SPOCK-EARS LP',
    lpAddresses: {
      97: '',
      250: '0xd70Fbe9201b0623063A84795B7BFac7cEF5e2886',
    },
    tokenSymbol: 'EARS',
    tokenAddresses: {
      97: '',
      250: '0x0ec4b89462557150302ac6e81270a081f2e3bd20',
    },
    quoteTokenSymbol: QuoteToken.CAKE,
    quoteTokenAdresses: contracts.cake,
  },
  {
    pid: 2,
    risk: 3,
    lpSymbol: 'BOO-FTM LP',
    lpAddresses: {
      97: '',
      250: '0xEc7178F4C41f346b2721907F5cF7628E388A7a58',
    },
    tokenSymbol: 'BOO',
    tokenAddresses: {
      97: '',
      250: '0x841FAD6EAe12c286d1Fd18d1d525DFfA75C7EFFE',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 3,
    risk: 3,
    lpSymbol: 'USDT-FTM LP',
    lpAddresses: {
      97: '',
      250: '0x5965E53aa80a0bcF1CD6dbDd72e6A9b2AA047410',
    },
    tokenSymbol: 'USDT',
    tokenAddresses: {
      97: '',
      250: '0x049d68029688eAbF473097a2fC38ef61633A3C7A',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 4,
    risk: 3,
    lpSymbol: 'USDC-FTM LP',
    lpAddresses: {
      97: '',
      250: '0x2b4C76d0dc16BE1C31D4C1DC53bF9B45987Fc75c',
    },
    tokenSymbol: 'USDC',
    tokenAddresses: {
      97: '',
      250: '0x04068DA6C83AFCFA0e13ba15A6696662335D5B75',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 5,
    risk: 3,
    lpSymbol: 'DAI-FTM LP',
    lpAddresses: {
      97: '',
      250: '0xe120ffBDA0d14f3Bb6d6053E90E63c572A66a428',
    },
    tokenSymbol: 'FTM',
    tokenAddresses: {
      97: '',
      250: '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 6,
    risk: 3,
    lpSymbol: 'WBTC-FTM LP',
    lpAddresses: {
      97: '',
      250: '0xFdb9Ab8B9513Ad9E419Cf19530feE49d412C3Ee3',
    },
    tokenSymbol: 'wBTC',
    tokenAddresses: {
      97: '',
      250: '0x321162Cd933E2Be498Cd2267a90534A804051b11',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 7,
    risk: 3,
    lpSymbol: 'ETH-FTM LP',
    lpAddresses: {
      97: '',
      250: '0xf0702249F4D3A25cD3DED7859a165693685Ab577',
    },
    tokenSymbol: 'ETH',
    tokenAddresses: {
      97: '',
      250: '0x74b23882a30290451A17c44f4F05243b6b58C76d',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 8,
    risk: 3,
    lpSymbol: 'LINK-FTM LP',
    lpAddresses: {
      97: '',
      250: '0x89d9bC2F2d091CfBFc31e333D6Dc555dDBc2fd29',
    },
    tokenSymbol: 'LINK',
    tokenAddresses: {
      97: '',
      250: '0xb3654dc3D10Ea7645f8319668E8F54d2574FBdC8',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 9,
    risk: 3,
    lpSymbol: 'AAVE-FTM LP',
    lpAddresses: {
      97: '',
      250: '0xeBF374bB21D83Cf010cC7363918776aDF6FF2BF6',
    },
    tokenSymbol: 'AAVE',
    tokenAddresses: {
      97: '',
      250: '0x6a07A792ab2965C72a5B8088d3a069A7aC3a993B',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 10,
    risk: 3,
    lpSymbol: 'SNX-FTM LP',
    lpAddresses: {
      97: '',
      250: '0x06d173628bE105fE81F1C82c9979bA79eBCAfCB7',
    },
    tokenSymbol: 'SNX',
    tokenAddresses: {
      97: '',
      250: '0x56ee926bD8c72B2d5fa1aF4d9E4Cbb515a1E3Adc',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 11,
    risk: 3,
    lpSymbol: 'SUSHI-FTM LP',
    lpAddresses: {
      97: '',
      250: '0xf84E313B36E86315af7a06ff26C8b20e9EB443C3',
    },
    tokenSymbol: 'SUSHI',
    tokenAddresses: {
      97: '',
      250: '0xae75A438b2E0cB8Bb01Ec1E1e376De11D44477CC',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 12,
    risk: 3,
    lpSymbol: 'BAND-FTM LP',
    lpAddresses: {
      97: '',
      250: '0x91b39D5584e2A7DC829f696235742cc293F2e8cf',
    },
    tokenSymbol: 'BAND',
    tokenAddresses: {
      97: '',
      250: '0x46E7628E8b4350b2716ab470eE0bA1fa9e76c6C5',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 13,
    risk: 3,
    lpSymbol: 'CREAM-FTM LP',
    lpAddresses: {
      97: '',
      250: '0xb77b223490e1f5951ec79A8d09Db9Eab2ADCB934',
    },
    tokenSymbol: 'CREAM',
    tokenAddresses: {
      97: '',
      250: '0x657A1861c15A3deD9AF0B6799a195a249ebdCbc6',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 14,
    risk: 3,
    lpSymbol: 'CRV-FTM LP',
    lpAddresses: {
      97: '',
      250: '0xB471Ac6eF617e952b84C6a9fF5de65A9da96C93B',
    },
    tokenSymbol: 'CRV',
    tokenAddresses: {
      97: '',
      250: '0x1E4F97b9f9F913c46F1632781732927B9019C68b',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 15,
    risk: 3,
    lpSymbol: 'BNB-FTM LP',
    lpAddresses: {
      97: '',
      250: '0x956DE13EA0FA5b577E4097Be837BF4aC80005820',
    },
    tokenSymbol: 'BNB',
    tokenAddresses: {
      97: '',
      250: '0xD67de0e0a0Fd7b15dC8348Bb9BE742F3c5850454',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 16,
    risk: 3,
    lpSymbol: 'WOOFY-FTM LP',
    lpAddresses: {
      97: '',
      250: '0xfD0aB56B83130ce8f2b7A4f4d4532dEe495c0794',
    },
    tokenSymbol: 'WOOFY',
    tokenAddresses: {
      97: '',
      250: '0xD0660cD418a64a1d44E9214ad8e459324D8157f1',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 17,
    risk: 3,
    lpSymbol: 'ANY-FTM LP',
    lpAddresses: {
      97: '',
      250: '0x5c021D9cfaD40aaFC57786b409A9ce571de375b4',
    },
    tokenSymbol: 'ANY',
    tokenAddresses: {
      97: '',
      250: '0xdDcb3fFD12750B45d32E084887fdf1aABAb34239',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 18,
    risk: 3,
    lpSymbol: 'BIFI-FTM LP',
    lpAddresses: {
      97: '',
      250: '0x1656728af3a14e1319F030Dc147fAbf6f627059e',
    },
    tokenSymbol: 'BIFI',
    tokenAddresses: {
      97: '',
      250: '0xd6070ae98b8069de6B494332d1A1a81B6179D960',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 19,
    risk: 3,
    lpSymbol: 'MIM-FTM LP',
    lpAddresses: {
      97: '',
      250: '0x6f86e65b255c9111109d2D2325ca2dFc82456efc',
    },
    tokenSymbol: 'MIM',
    tokenAddresses: {
      97: '',
      250: '0x82f0B8B456c1A451378467398982d4834b6829c1',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 20,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'SPOCK',
    lpAddresses: {
      97: '',
      250: '0x0De9Ed19acd438B3AE7ab468AB6c5C2C788aE1EA', // SPOCK-DAI LP
    },
    tokenSymbol: 'SPOCK',
    tokenAddresses: {
      97: '',
      250: '0xE2463256E69E4C86345DC32e2FFED3283b0022e8',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 22,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'KLING',
    lpAddresses: {
      97: '',
      250: '0x461BBDEBa1751A76584DF3a0310E0926663Ea6C0', // KLING-FTM LP
    },
    tokenSymbol: 'KLING',
    tokenAddresses: {
      97: '',
      250: '0x983235dC2a7b5e5a0820066480b19f04EEf83986',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 23,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'BOO',
    lpAddresses: {
      97: '',
      250: '0xEc7178F4C41f346b2721907F5cF7628E388A7a58', // BOO-FTM LP
    },
    tokenSymbol: 'BOO',
    tokenAddresses: {
      97: '',
      250: '0x841FAD6EAe12c286d1Fd18d1d525DFfA75C7EFFE',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 24,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'Spirit',
    lpAddresses: {
      97: '',
      250: '0x30748322B6E34545DBe0788C421886AEB5297789', // Spirit-FTM LP
    },
    tokenSymbol: 'Spirit',
    tokenAddresses: {
      97: '',
      250: '0x5Cc61A78F164885776AA610fb0FE1257df78E59B',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 25,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'WFTM',
    lpAddresses: {
      97: '',
      250: '0xe120ffBDA0d14f3Bb6d6053E90E63c572A66a428', // Spirit-FTM LP
    },
    tokenSymbol: 'WFTM',
    tokenAddresses: {
      97: '',
      250: '0x21be370D5312f44cB42ce377BC9b8a0cEF1A4C83',
    },
    quoteTokenSymbol: QuoteToken.BUSD,
    quoteTokenAdresses: contracts.busd,
  },
  {
    pid: 26,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'fUSD',
    lpAddresses: {
      97: '',
      250: '0x8Ec0417A4C795074F076519afD4410484C9830Ef', // fUSD-FTM LP
    },
    tokenSymbol: 'fUSD',
    tokenAddresses: {
      97: '',
      250: '0xAd84341756Bf337f5a0164515b1f6F993D194E1f',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 27,
    risk: 5,
    isTokenOnly: true,
    lpSymbol: 'ifUSD',
    lpAddresses: {
      97: '',
      250: '0x02376D39c7cdC95207969F53958C09a69e70B155', // ifUSD-FTM LP
    },
    tokenSymbol: 'ifUSD',
    tokenAddresses: {
      97: '',
      250: '0x9fC071cE771c7B27b7d9A57C32c0a84c18200F8a',
    },
    quoteTokenSymbol: QuoteToken.BNB,
    quoteTokenAdresses: contracts.wbnb,
  },
  {
    pid: 28,
    risk: 5,
    lpSymbol: 'SPOCK-EARS LP',
    lpAddresses: {
      97: '',
      250: '0xd70Fbe9201b0623063A84795B7BFac7cEF5e2886',
    },
    tokenSymbol: 'EARS',
    tokenAddresses: {
      97: '',
      250: '0x0ec4b89462557150302ac6e81270a081f2e3bd20',
    },
    quoteTokenSymbol: QuoteToken.CAKE,
    quoteTokenAdresses: contracts.cake,
  },
]

export default farms
